module.exports = __webpack_public_path__ + "img/right.e4a80fe8.png";